import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';
import { colors } from 'theme/colors';

const StyledCardLink = styled(Box)`
  display: flex;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border: 1px solid ${colors.blue100};
  box-shadow: 0 2px 4px rgba(194, 204, 243, 0.35), 0 2px 6px rgba(194, 204, 243, 0.3),
    0 4px 8px rgba(194, 204, 243, 0.2), 0 6px 10px rgba(194, 204, 243, 0.2);
  border-radius: 4px;
  justify-content: space-between;
  gap: 8px;
`;

const StyledCardLinkIcon = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 2.86px;
  background: ${colors.blue50};
`;

export { StyledCardLink, StyledCardLinkIcon };
